export const isTokenValid = (): boolean => {
  const token = localStorage.getItem('token');
  if (!token) return false;

  try {
    // 这里可以添加 token 的有效性验证逻辑
    // 比如检查是否过期等
    return true;
  } catch (error) {
    return false;
  }
}; 